import NearProductsList from './NearProductsList'

export default NearProductsList
